import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Search } from 'lucide-react';
import { articles } from '../mock';

const Articles = () => {
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('All');
  const categories = useMemo(
    () => ['All', ...Array.from(new Set(articles.map(a => a.category)))],
    []
  );
  const filtered = useMemo(
    () => articles.filter(a =>
      (cat === 'All' || a.category === cat) &&
      (a.title.toLowerCase().includes(q.toLowerCase()) || a.excerpt.toLowerCase().includes(q.toLowerCase()))
    ),
    [q, cat]
  );

  return (
    <div className="fade-in">
      <section className="hero-gradient border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 py-20">
          <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">Articles</div>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-3xl">Regulatory analysis, written for practice owners.</h1>
          <p className="mt-5 text-[17px] text-slate-700 max-w-2xl">Concise, cited, and scholarly-authoritative commentary on the frameworks that govern small regulated practices.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-stretch md:items-center gap-4 mb-10">
            <div className="relative flex-1">
              <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search articles…" className="w-full border border-slate-300 rounded-sm pl-10 pr-3 py-2.5 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/50 focus:border-[#2E75B6]" />
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map(c => (
                <button key={c} onClick={() => setCat(c)} className={`text-[13px] px-3.5 py-2 rounded-sm border transition-colors ${cat === c ? 'bg-[#1F3864] text-white border-[#1F3864]' : 'bg-white text-slate-700 border-slate-300 hover:border-[#1F3864] hover:text-[#1F3864]'}`}>{c}</button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {filtered.map(a => (
              <Link key={a.slug} to={`/articles/${a.slug}`} className="card-hover group block bg-white border border-slate-200 rounded-sm p-7">
                <div className="flex items-center gap-3 text-[12px] uppercase tracking-widest text-slate-500 mb-4">
                  <span className="text-[#1F3864] font-semibold">{a.category}</span>
                  <span className="text-slate-300">|</span>
                  <span>{a.date}</span>
                </div>
                <h3 className="font-serif-display text-[22px] leading-snug text-[#1F3864] group-hover:underline decoration-[#2E75B6] underline-offset-4">{a.title}</h3>
                <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">{a.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-[13.5px] font-medium text-[#2E75B6] group-hover:gap-2.5 transition-all">Read article <ArrowRight size={14} /></div>
              </Link>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-16 text-slate-500">No articles match your filters.</div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Articles;
